import { render, staticRenderFns } from "./PrescriptionsPanel.vue?vue&type=template&id=74e7a40c&scoped=true&"
import script from "./PrescriptionsPanel.vue?vue&type=script&lang=js&"
export * from "./PrescriptionsPanel.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionsPanel.vue?vue&type=style&index=0&id=74e7a40c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e7a40c",
  null
  
)

export default component.exports